import React from 'react';
import { ErrorPage } from '@zillow/zrs-zillow-offers';
import { RouteList } from '@zg-rentals/route-list';
import STRING_CONSTANTS from 'app/shared/constants/StringConstants';

const NotFoundPage = () => (
    <>
        <ErrorPage
            homePageText={STRING_CONSTANTS.ZILLOW_ERROR_COPY}
            homePageUrl={STRING_CONSTANTS.ZILLOW_PRICE_MY_RENTAL_PATH}
        />
        {__DEV__ && <RouteList />}
    </>
);

export default NotFoundPage;
